import React, { lazy, Suspense } from "react";
import { IDashboardComponent } from "api/model/dashboard/DashboardComponent";
import { loadComponentModule } from "components/ComponentType";
import { ProgressSpinner } from "primereact/progressspinner";
import "../../dashboard-styles/Dashboard.scss";
import useIsMobile from "hooks/useIsMobile";
import ErrorBoundary from "../error-boundary/ErrorBoundary";

interface IDashboardComponentCardProps {
  component: IDashboardComponent;
}

const DashboardComponentCard = ({ component }: IDashboardComponentCardProps) => {
  const isMobile = useIsMobile();

  const LazyComponent = lazy(async () => {
    const loadedModule = await loadComponentModule(component.type);
    return { default: loadedModule.default };
  });

  return (
    <div className="easas-dashboard-component">
      <ErrorBoundary errorMessage={component.type === "NOT_SUPPORTED" ? "Component is not supported" : undefined}>
        <Suspense fallback={<ProgressSpinner />}>
          {component.title && !isMobile && <h4>{component.title}</h4>}
          {component.title && isMobile && <h6>{component.title}</h6>}
          <div className="easas-dashboard-component-content">
            <LazyComponent {...component.config} />
          </div>
        </Suspense>
      </ErrorBoundary>
    </div>
  );
};

export default DashboardComponentCard;
